<template>
  <div v-show="!(field.hide && field.hide())">
    <div v-show="pageMode == 'view' || pageMode == 'assignee'" :key="name + '_output'"  class="form-field-view">
      <template
        v-if="field.linkBase"
      >
        <md-field :key="name" :class="[
                  { 'md-error': hasRequirements && isInvalid },
                  { 'md-valid': hasRequirements && !isInvalid },
                  { '_uiKitInput': isUiKit },
                ]"
        >
          <label>{{ field.label }}</label>
          <!-- v-model="$vo[name].value.$model" -->
          <md-input
            type="text"
            :key="name"
            :name="name"
            v-model="$vo[name].$model"
            disabled
            style="visibility: hidden"
          ></md-input>
          <a style="position: absolute;top: 8px;" :href="field.linkBase + $vo[name].$model">{{ $vo[name].$model ? field.searchTerm : '' }}</a>
          <md-icon v-if="hasRequirements && isInvalid">clear</md-icon>
          <md-icon v-else-if="hasRequirements && !isInvalid">done</md-icon>
        </md-field>

      </template>
      <template
        v-else>
        <span>{{field.label}}:</span><br/>{{field.searchTerm}}
      </template>
    </div>
    <md-autocomplete v-show="pageMode != 'view' && pageMode !== 'assignee'" 
                     ref="autocompleteRef" 
                     :key="name + '_input'"
                     md-dense
                     :value="field.searchTerm" 
                     :md-options="field.options"
                     :disabled="field.preventEdit"
                     @md-selected="field.select"
                     @md-changed="onSearch"
                     @md-opened="triggerResize"
                     :class="[
                { 'md-valid': !$vo[name].$invalid },
                { 'md-error': $vo[name].$invalid },
                { '_uiKitInput': isUiKit },
              ]"
    >
      <label>{{ field.label }}</label>
      <template slot="md-autocomplete-item" slot-scope="{ item }">
        {{ field.displayFieldOne ? field.displayFieldTwo ? item[field.displayFieldOne] + ' ' + item[field.displayFieldTwo] : item[field.displayFieldOne] : item.name}}
        
      </template>
      <md-icon v-if="$vo[name] && Object.keys($vo[name].$params).length && $vo[name].$invalid">clear</md-icon>
      <md-icon v-else-if="$vo[name] && Object.keys($vo[name].$params).length && !$vo[name].$invalid">done</md-icon>
    </md-autocomplete>
  </div>
</template>

<script>
  import autoCompleteMixin from '@/mixins/autoCompleteMixin';
  export default {
    name: "crud-autocomplete",
    components: {},
    mixins: [autoCompleteMixin],
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      isUiKit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {
        timeoutId: null,
      }
    },
    computed: {
      isInvalid: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length && v.$invalid) result = true;
        return result;
      },
      hasRequirements: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length) result = true;
        return result;
      },
      isUnique() {
        if (undefined == this.$vo[this.name].isUnique || this.$vo[this.name].$pending) {
          return true;
        }
        return this.$vo[this.name].isUnique;
      },
    },
    methods: {
      getV: function () {
        // if (this.$vo && this.name && this.$vo[this.name] && this.$vo[this.name].value !== 'undefined') {
        //   return this.$vo[this.name].value || false;
        if (this.$vo && this.name && this.$vo[this.name] !== 'undefined') {
          return this.$vo[this.name] || false;
        } else {
          return false;
        }
      },
      /**
       * ATLAS-628 Services CRUD: Processor field data in list is showing truncated
       * 
       * Global fix on Autocomplete input type to refresh the vue-grid-layout on input change
       * Call this method on @md-opened
       */
      triggerResize() {
        window.setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 300);
        // Dispatch resize event so that vue material autocomplete resizes itself
        window.setImmediate(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
    watch: {
      /**
       * Watch for changed to data and updated autocomplete options
       * If value is already set or not data available then bail
       */
      'field.data': {
        immediate: true,
        handler: function() {
          const value = this.$reduce(this, `$vo.${this.name}.$model`);
          if (value || !this.field.data) {
            return;
          }
          this.$set(this.field, 'options', new Promise(resolve => resolve(this.field.data)));
        }
      },
      'pageMode' : {
        handler: function(){
          if(this.$vo[this.name].$model == '') {
            window.setTimeout(() => {
              this.$refs.autocompleteRef.searchTerm = ''; 
            }, 100)
          }
        } 
      }
    }
  };
</script>
